"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var FADE_IN_MS = 700;
var FADE_OUT_MS = 1000;
var fadeInStyles = {
  transition: "opacity ".concat(FADE_IN_MS, "ms ease-in-out"),
  opacity: 1
};
var fadeOutStyles = {
  transition: "opacity ".concat(FADE_OUT_MS, "ms ease-in-out"),
  opacity: 0
};
var AnimatedContent = function AnimatedContent(_ref) {
  var content = _ref.content,
    iterationId = _ref.iterationId,
    renderContent = _ref.renderContent;
  var isContentArray = Array.isArray(content);
  var _React$useState = _react["default"].useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    contentIndex = _React$useState2[0],
    setContentIndex = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    fadeIn = _React$useState4[0],
    setFadeIn = _React$useState4[1];
  var timeoutRef = _react["default"].useRef();
  var transitionToNextContentItem = function transitionToNextContentItem() {
    setFadeIn(false);
    timeoutRef.current = setTimeout(function () {
      setContentIndex(function (prevContentIndex) {
        return prevContentIndex === content.length - 1 ? 0 : prevContentIndex + 1;
      });
      setFadeIn(true);
    }, FADE_OUT_MS);
  };
  _react["default"].useEffect(function () {
    if (!isContentArray) {
      return;
    }
    return function () {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isContentArray]);
  _react["default"].useEffect(function () {
    if (!isContentArray) {
      return;
    }
    transitionToNextContentItem();
    return function () {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [iterationId]);
  if (isContentArray) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: fadeIn ? fadeInStyles : fadeOutStyles
    }, renderContent(content[contentIndex]));
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, renderContent(content));
};
AnimatedContent.propTypes = {
  content: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]).isRequired,
  iterationId: _propTypes["default"].number.isRequired,
  renderContent: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = AnimatedContent;